module.exports = __webpack_public_path__ + "static/10-4c4bcaf89a9ce8c9281f55f29cfa2a57.jpg";